import React, { useState } from 'react';
import { Box, Card, CardHeader, CardContent, Typography } from '@mui/material';
import HighCostTable from './components/HighCostTable';
import { useTranslation } from 'react-i18next';

function HighCostPanel() {
  const { t } = useTranslation();
  const [selectedLocation, setSelectedLocation] = useState("");

  return (
    <Box sx={{ padding: '10px', width: '100%' }}>
      <Box sx={{ width: '100%', mt: 2 }}>
        <Card elevation={3} sx={{ width: "100%" }}>
          <CardHeader
            title={
              <Typography variant="h5" sx={{ color: "primary.main", fontWeight: "bold" }}>
                {t("Main.HighCost.HighCostPatients")}
              </Typography>
            }
          />
          <CardContent>
            <Box sx={{ width: "100%" }}>
              <HighCostTable
                selectedLocation={selectedLocation}
                setSelectedLocation={setSelectedLocation}
              />
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}

export default HighCostPanel;
